import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";

import { toast } from "react-toastify";

import {
  appserveraddr,
  dmscoreservicecontextname,
  getincidentcatcreate,
  getThemeURL,
  deleteincident,
} from "../../../Services/EndPoints";

import Moment from "react-moment";
import {
  masterResourcecolumnsForExport,
} from "../../../JsonData/MasterResourceConfig";

import Loader from "react-spinner-loader";
import { useTranslation } from "react-i18next";
import Confirmpopup from "../Common/ConfirmPopup/Confirmpopup";
import { getExportedColumnsData } from "../../../Components/UiComponents/utils";
import {
  Deleteicon,
  Editicon,
  MapIcon,
} from "../../../Components/IconComponents";

import {
  getData,
  postDataWithBody,
} from "../../../Services/Services";
import { setTableData } from "../../../CentralStore/ExportLMSTable/dataSlice";
import IncidentShowTableData from "../../../Components/UiComponents/Table/IncidentShowTableData";
import { RoleContext } from "../../..";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const IncidentTable = ({ onRowClick, selectedRowId, refreshTrigger }) => {
  const { roleName } = useContext(RoleContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  // const qs = require("qs");
  // const [masterResourceData, setMasterResourceData] = useState(
  //   masterResourceTableData
  // );
  const [searchData, setSearchData] = useState([]);
  const [rowCount, setRowCount] = useState(0);

  const { t } = useTranslation();
  useEffect(() => {
    getMasterResourceList();
  }, [refreshTrigger]);

  useEffect(() => {
    sendDataToCentralStore(searchData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData]);

  async function getMasterResourceList() {
    setLoader(true);

    let masterResourceList = await getData(getincidentcatcreate);

    let sortedList = masterResourceList.sort((a, b) => {
      return new Date(b.created_on) - new Date(a.created_on);
    });
    setLoader(false);

    setRowCount(sortedList.length);
    setData(sortedList);
  }
  const sendDataToCentralStore = (data) => {
    if (data.length > 0) {
      const columns = masterResourcecolumnsForExport;
      dispatch(
        setTableData({
          columns,
          tableData: getExportedColumnsData(columns, data),
        })
      );
    }
  };
  const addNewHandler = () => {
    navigate("/situation-awareness/create-incidentpage");
  };
// eslint-disable-next-line no-unused-vars
  const getImageWithAuth = async (imageName) => {
    const imageUrl = `${appserveraddr}/${dmscoreservicecontextname}/master_resource/get_resource_image/${imageName}`;

    try {
      const response = await fetch(imageUrl, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("auth_token"),
        },
      });

      if (response.ok) {
        const blob = await response.blob(); // Convert the response to a Blob
        const reader = new FileReader();
        return new Promise((resolve, reject) => {
          reader.onloadend = () => {
            // Return the Base64-encoded string (exclude the data URL prefix part)
            resolve(reader.result.split(",")[1]);
          };
          reader.onerror = reject;
          reader.readAsDataURL(blob); // Read the Blob as a Data URL (Base64)
        });
      } else {
        console.error("Failed to fetch image:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("Error fetching image:", error);
      return null;
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: t("S.No."), // Changed from "ID" to "S.No."
        accessor: "serialNo", // Changed accessor to serialNo
        Cell: (props) => {
          // Calculate serial number based on row index
          const serialNo = props.row.index + 1;
          const isSelected = selectedRowId === props.row.original.id;
          return (
            <span
              style={{ cursor: "pointer" }}
              onClick={() => onRowClick(props.row.original.id)}
              title={serialNo.toString()}
            >
              {serialNo}
            </span>
          );
        },
        disableSortBy: true,
        leftAlign: true,
      },
      {
        Header: t("Incident Name"),
        accessor: "name",
        Cell: (props) => {
          if (props.value) {
            let categoryText = props.value;
            if (props.value.length > 15) {
              categoryText = props.value.substring(0, 15) + "...";
            }
            return <span title={props.value}>{categoryText}</span>;
          } else {
            return "NA";
          }
        },
        disableSortBy: true,
        leftAlign: true,
      },
      {
        Header: t("Incident Category"),
        accessor: "category",
        Cell: (props) => {
          if (props.value) {
            let name = props.value;
            if (props.value.length > 15) {
              name = props.value.substring(0, 15) + "...";
            }
            return <span title={props.value}>{name}</span>;
          } else {
            return "NA";
          }
        },
        disableSortBy: true,
        leftAlign: true,
      },

      {
        Header: t("Incident Description"),
        accessor: "description",
        Cell: (props) => {
          if (props.value) {
            let des = props.value;
            if (props.value.length > 15) {
              des = props.value.substring(0, 15) + "...";
            }
            return <span title={props.value}>{des}</span>;
          } else {
            return "NA";
          }
        },

        disableSortBy: true,
        leftAlign: true,
      },

      {
        Header: t("Incident Created By"),
        accessor: "created_by",
        disableSortBy: true,
        leftAlign: true,
      },
      {
        Header: t("Incident Date & Time"),
        accessor: "created_on",
        Cell: (props) => {
          if (props.value) {
            return <Moment format="DD/MM/YYYY, HH:mm">{props.value}</Moment>;
          } else {
            return "NA";
          }
        },
        disableSortBy: true,
        leftAlign: true,
      },

      {
        Header: t("masterresourcetableheaders.action"),
        disableSortBy: true,

        Cell: (props) => {
          const [isdelete, setIsdelete] = useState(false);
          const [selectedId, setSelectedId] = useState(null);

          const [username, setusername] = useState("");
          const getUserdataprof = async () => {
            try {
              const usr_prof = await getData(getThemeURL);
              setusername(usr_prof[0].user_name);
            } catch (error) {}
          };
          const deletePopUp = (id) => {
            // Check if delete is disabled
            if (!props.row.original.disableEditDelete) {
              return; // Don't proceed with delete if disabled
            }

            getUserdataprof();
            setSelectedId(id);
            setIsdelete(!isdelete);
          };
          const deleteTableDataById = async () => {
            try {
              const req = {
                incidentId: selectedId,
                userId: username,
              };
              const response = await postDataWithBody(deleteincident, req, {});
              if (response?.status === "success") {
                await getMasterResourceList();
                toast.success(t("Incident deleted successfully"), {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                });
              }
            } catch (error) {
              toast.error(t("delete_error_message"), {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
              });
              console.error("Delete error:", error);
            } finally {
              setIsdelete(false);
              setSelectedId(null);
            }
          };

          const handleDelete = () => {
            // Check if delete is disabled
            if (!props.row.original.disableEditDelete) {
              return; // Don't proceed with delete if disabled
            }

            // getUserdataprof()
            deleteTableDataById();
            //deleteTableDataImageByName();
          };

          return (
            <div className="usertable__actionsicon">
              <span
                onClick={() => {
                  // Log the image name
                  navigate("../situation-awareness", {
                    state: {
                      id: props.row.original.id,
                      // imgName: props.row.original.resource_image_name, // Pass the image name in the state
                      tabvv: true,
                    },
                  });
                }}
              >
                <MapIcon value={props.value} className="cursor-pointer me-2" />
              </span>
              {roleName === process.env.REACT_APP_SUPER_ADMIN && (
                <span
                  onClick={() => {
                    // Log the image name
                    navigate("/situation-awareness/create-incidentpage", {
                      state: {
                        id: props.row.original.id,
                        // imgName: props.row.original.resource_image_name, // Pass the image name in the state
                        edit: true,
                      },
                    });
                  }}
                >
                  <Editicon
                    value={props.value}
                    className="cursor-pointer me-2"
                  />
                </span>
              )}

              {roleName === process.env.REACT_APP_SUPER_ADMIN &&
                (!props.row.original.disableEditDelete ? (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip>
                        {t(
                          "Selected Incident can't be deleted as event/s or sop/s are attached to this incident"
                        )}
                      </Tooltip>
                    }
                  >
                    <span>
                      <Deleteicon
                        value={props.value}
                        className="cursor-pointer mr-1 disabled-icon"
                        style={{ opacity: 0.5, cursor: "not-allowed" }}
                      />
                    </span>
                  </OverlayTrigger>
                ) : (
                  <span onClick={() => deletePopUp(props.row.original.id)}>
                    <Deleteicon
                      value={props.value}
                      className="cursor-pointer mr-1"
                    />
                  </span>
                ))}

              {isdelete && (
                <Confirmpopup
                  show={isdelete}
                  title={t("deletepopuptext")}
                  message={t("deletepopupmessage")}
                  handleToggle={deletePopUp}
                  row={props.row}
                  name={props.row.original.activity}
                  deleteRow={handleDelete}
                  cancel={t("cancelbutton")}
                  action={t("actionbutton")}
                />
              )}
            </div>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, onRowClick, selectedRowId, roleName]
  );
  return (
    <div className="create-user">
      <Loader
        show={loader}
        type="body"
        stack="vertical"
        message="Loading Data"
      />
      <div className="datatable__container">
        {data && (
          <IncidentShowTableData
            data={data}
            addButtonLabel={t("Create Incident")}
            addNewHandler={addNewHandler}
            onRowClick={onRowClick}
            selectedRowId={selectedRowId}
            setSearchData={setSearchData}
            columns={columns}
            numberOfRows={10}
            rowCount={rowCount}
            showExport={false}
            showFilter={false}
            showReset={false}
            onExpand={false}
            headerTableHeadStyle={{ background: "#18a3a0", color: "#FFFFFF" }}
            tableStyle={{
              border: "1px solid  #f0f0f0",
              borderRadius: "12px",
            }}
          />
        )}
      </div>
    </div>
  );
};

export default IncidentTable;